import {Col, Form, Row} from "react-bootstrap";
import {ModalDialog} from "../modal/ModalDialog.js";
import React from "react";
import {APIClient} from "../../core/utils/APIClient.js";
import useForm from "../../core/hooks/useForm.js";

export default function MarketModal({setModal, articleId, articleName, retailerId, retailerName, countryName, url, refreshArticleScanners}) {
    const {form, onInputChange} = useForm({
        url
    });

    const onModalSaveClick = async () => {
        try {
            if (form.price) {
                await APIClient().saveArticlePrice(articleId, retailerId, form.price);
            }
            if (form.url) {
                await APIClient().upsertArticleScanner(articleId, retailerId, form.url);
            }

            setModal({
                show: false
            });
            refreshArticleScanners();
        } catch (e) {
            console.error(e);
        }
    }

    const onModalClose = () => {
        setModal({
            show: false
        });
    }

    return (
        <ModalDialog show onClose={onModalClose} onCallback={onModalSaveClick} title={`${articleName} - ${countryName} - ${retailerName} - Edit`}>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="3">
                    Price
                </Form.Label>
                <Col sm="9">
                    <Form.Control type="text" name="price" value={form.price || ''} onChange={onInputChange} />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="3">
                    Url
                </Form.Label>
                <Col sm="9">
                    <Form.Control type="text" name="url" value={form.url || ''} onChange={onInputChange} />
                </Col>
            </Form.Group>
        </ModalDialog>
    );
}
